<template>
  <a-modal :title="title"
           :width="800"
           :visible="visible"
           @ok="onSave"
           @cancel="onCancel"
           :confirmLoading="confirmLoading">
    <a-form-model ref="contentForm"
                  :model="formData"
                  :rules="getRules"
                  :label-col="{ span: 4 }"
                  :wrapper-col="{ span: 20 }">
      <a-form-model-item label='内容名称'
                         prop="contentName">
        <a-input placeholder='内容名称'
                 v-model="formData.contentName"/>
      </a-form-model-item>
      <a-form-model-item label='内容标识'
                         prop="contentKey">
        <a-input placeholder='内容标识' :disabled="mode ==='edit'"
                 v-model="formData.contentKey"/>
      </a-form-model-item>
      <template v-if="actionType===ACTION_TYPE.system">
        <a-form-model-item label='内容类型'>
          <dict-radio v-model="formData.contentType"
                      dictKey="sys_content_mange_type"
                      placeholder="内容类型"
                      @change="(val) => { formData.contentType = val }"/>
        </a-form-model-item>
        <a-form-model-item label='内容'
                           prop="contentResource">
          <a-upload list-type="picture-card"
                    :file-list="fileList"
                    accept="image/*"
                    :remove="handleRemove"
                    :before-upload="beforeUpload"
                    @preview="handlePreview"
                    v-if="formData.contentType==='1'">
            <div v-if="fileList.length < 1">
              <a-icon type="plus"/>
              <div class="ant-upload-text">
                上传图片
              </div>
            </div>
          </a-upload>
          <a-input v-else
                   v-model="formData.contentResource"
                   placeholder='请输入内容'></a-input>
        </a-form-model-item>
      </template>
      <a-form-model-item label='内容' v-else
                         prop="contentResource">
        <a-input
            v-model="formData.contentResource"
            placeholder='请输入内容'></a-input>
      </a-form-model-item>
      <a-form-model-item label='描述'>
        <a-textarea placeholder='描述'
                    v-model="formData.remark"/>
      </a-form-model-item>
    </a-form-model>
    <a-modal :visible="previewVisible"
             :footer="null"
             :dialog-style="{ top: '20px' }"
             width="70%"
             @cancel="handlePreviewCancel">
      <img alt="example"
           style="width: 100%"
           :src="formData.contentResource"/>
    </a-modal>
  </a-modal>
</template>

<script>
import DictRadio from '@/components/dict/DictRadio'
import { AddSysContentInfo, EditSysContentInfo, GetInfoById } from '@/epp/sysContentMange/api/sysContentMangeApi'
import { ACTION_TYPE } from '@/epp/sysContentMange/util/sysContentMangeUtil'

export default {
  name: 'SysContentMangeEditModel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    actionType: {
      type: String,
      default: '0'
    }
  },
  components: {
    DictRadio
  },
  data () {
    return {
      previewVisible: false,
      ACTION_TYPE,
      mode: '',
      title: '',
      formData: { contentName: '', contentKey: '', contentType: '2', contentResource: '', remark: '' },
      confirmLoading: false,
      rules: {
        contentName: [
          { required: true, message: '请输入内容名称', trigger: 'blur' },
        ],
        contentKey: [
          { required: true, message: '请输入内容标识', trigger: 'blur' },
        ],
        contentResource: [{ required: true, message: '请填写内容', trigger: 'blur' },]
      },
      fileList: []
    }
  },
  computed: {
    getRules () {
      this.rules['contentResource'][0].message = this.actionType === ACTION_TYPE.business ? '请填写内容' : this.formData.contentType === '1' ? '请上传图片' : '请填写内容'
      return this.rules
    }
  },
  methods: {
    preAdd: function () {
      this.title = '添加'
      this.mode = 'add'
    },
    preEdit: function (id) {
      this.title = '编辑'
      this.mode = 'edit'

      let that = this
      GetInfoById(id).then(function (response) {
        if (response.code === 200) {
          let formData = response.result
          that.formData = formData
          that.fileList = [{
            uid: formData.id,
            name: formData.contentName,
            status: 'done',
            url: formData.contentResource
          }]
        }
      })
    },
    handleRemove () {
      this.fileList = []
      this.formData.contentResource = ''
    },
    async beforeUpload (file) {
      return new Promise(async (resolve, reject) => {
        const contentResource = await this.getBase64(file)
        this.formData.contentResource = contentResource
        this.fileList = [{
          uid: file.uid,
          name: file.name,
          status: 'done',
          url: contentResource,
        },]
        return reject(false)
      })
    },
    onSave () {
      let that = this
      this.$refs.contentForm.validate(valid => {
        if (!valid) {
          return
        }
        this.confirmLoading = true
        if (that.mode === 'add') {
          this.formData.actionType = this.actionType
          AddSysContentInfo(this.formData).then(function (res) {
            if (res.code === 200) {
              that.$message.success('添加成功')
              that.confirmLoading = false
              that.$emit('success', that.mode)
              that.onCancel()
            } else {
              that.$message.error('添加失败')
              that.confirmLoading = false
            }
          })
        } else {
          EditSysContentInfo(this.formData).then(function (res) {
            if (res.code == 200) {
              that.$message.success('修改成功')
              that.confirmLoading = false
              that.onCancel()
              that.$emit('success', that.mode)
            } else {
              that.$message.error('修改失败')
              that.confirmLoading = false
            }
          })
        }
      })
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onCancel () {
      this.$refs.contentForm.resetFields()
      this.formData = { contentName: '', contentKey: '', contentType: '2', contentResource: '', remark: '' }
      this.handleRemove()
      this.$emit('cancel')
    },
    handlePreview (file) {
      this.previewVisible = true
    },
    handlePreviewCancel () {
      this.previewVisible = false
    }
  }
}
</script>

<style scoped>
</style>
